import { Input, InputProps } from '@farol-ds/react'
import { composeRefs } from '@radix-ui/react-compose-refs'
import { ChangeEvent, ComponentType, forwardRef, Ref } from 'react'
import { IMaskMixin } from 'react-imask'

interface IMaskMixinProps extends InputProps {
  inputRef?: Ref<HTMLInputElement>
  __INTERNAL_REF__?: Ref<HTMLInputElement>
}

const InputIMaskInternal = IMaskMixin(
  ({ inputRef, __INTERNAL_REF__, ...props }: IMaskMixinProps) => (
    <Input {...props} ref={composeRefs(inputRef, __INTERNAL_REF__)} />
  )
)

export type InputIMaskProps = typeof InputIMaskInternal extends ComponentType<infer T> ? T : never

export const InputIMask = forwardRef<HTMLInputElement, InputIMaskProps>(function InputIMaskWithRef(
  props,
  ref
) {
  const { onChange, ...rest } = props
  return (
    <InputIMaskInternal
      {...rest}
      onAccept={(_, __, evt) => {
        if (onChange && evt) {
          return onChange(evt as unknown as ChangeEvent<HTMLInputElement>)
        }
      }}
      {...{ __INTERNAL_REF__: ref }}
    />
  )
})
